export const productData = [
 
  {
    id: 9,
    imgUrl:
      "https://bisarga.com/wp-content/uploads/2021/06/India-Gate-Basmati-Rice-Bag-Super-5kg.jpg",
    name: ["rice", "chawal","all"],
    price: 400,
    para: "Bashmati rice",
    weight: "5kg",
  },
  {
    id: 10,
    imgUrl:
      "https://content.jdmagicbox.com/quickquotes/images_main/-g7zjtfvq.png?impolicy=queryparam&im=Resize=(360,360),aspect=fit",
    name: ["aata", "flour","all"],
    price: 300,
    para: " Aashirwad Flour",
    weight: "5kg",
  },
  {
    id: 11,
    imgUrl:
      "https://cdn.grofers.com/cdn-cgi/image/f=auto,fit=scale-down,q=70,metadata=none,w=270/app/assets/products/sliding_images/jpeg/0c0170fb-baf2-4947-b512-a6f0a5e6ad01.jpg?ts=1711024455",
    name: ["simal", "shimala", "simala", "sabji","all"],
    price: 50,
    para: "Simla",
    weight: "500g",
  },
  {
    id: 12,
    imgUrl:
      "https://m.media-amazon.com/images/I/51DJ-9xkuQL._AC_UF1000,1000_QL80_.jpg",
    name: ["pyaj", "onion", "sabji","all"],
    price: 60,
    para: "onion",
    weight: "1kg",
  },
  {
    id: 13,
    imgUrl:
      "https://cdn.grofers.com/cdn-cgi/image/f=auto,fit=scale-down,q=70,metadata=none,w=270/da/cms-assets/cms/product/2053a0d2-82b3-4ab3-a2f0-da4fe15df384.jpg?ts=1729165845",
    name: ["Egg", "andda", "anda", "hot","all"],
    price: 40,
    para: "Egg",
    weight: "3 pieces",
  },
  {
    id: 14,
    imgUrl:
      "https://cdn.grofers.com/cdn-cgi/image/f=auto,fit=scale-down,q=70,metadata=none,w=270/app/images/products/sliding_image/14795a.jpg?ts=1698148037",
    name: ["Brinjal", "baigan", "sabji","all"],
    price: 50,
    para: "Brinjal",
    weight: "1 kg",
  },
  {
    id: 15,
    imgUrl:
      "https://cdn.grofers.com/cdn-cgi/image/f=auto,fit=scale-down,q=70,metadata=none,w=270/app/assets/products/sliding_images/jpeg/b5fc630a-c183-47e8-979e-20c04f601039.jpg?ts=1722934673",
    name: ["Tomato", "sabji", "tomatar","all"],
    price: 50,
    para: "Tomato",
    weight: "500g",
  },
  {
    id: 16,
    imgUrl:
      "https://cdn.grofers.com/cdn-cgi/image/f=auto,fit=scale-down,q=70,metadata=none,w=270/da/cms-assets/cms/product/c11437d7-3fa3-454c-a5b1-ec2dc911c014.jpg?ts=1734429255",
    price: 50,
    name: ["Potato", "aalu", "sabji","all"],
    para: "Potato",
    weight: "1 kg",
  },
  {
    id: 17,
    imgUrl:
      "https://cdn.grofers.com/cdn-cgi/image/f=auto,fit=scale-down,q=70,metadata=none,w=270/da/cms-assets/cms/product/107f1c0e-6648-4de2-852e-ab2325e44afb.jpg?ts=1735364289",
    price: 30,
    name: ["Gobhi", "gobhi", "fulgobhi", "sabji","all"],
    para: "Gobhi",
    weight: "500g",
  },
  {
    id: 18,
    imgUrl:
      "https://5.imimg.com/data5/NU/LA/GLADMIN-10870697/sudha-healthy-toned-milk.png",
    price: 50,
    name: ["milk", "dudh", "sudha", "dairy","all"],
    para: "milk",
    weight: "500g",
  },
  {
    id: 19,
    imgUrl:
      "https://ueirorganic.com/cdn/shop/files/purecowghee.jpg?v=1689066451",
    price: 500,
    name: ["ghee", "ghi", "cow ghee", "desi ghee", "dairy","all"],
    para: "ghee",
    weight: "500g",
  },
  {
    id: 20,
    imgUrl:
      "https://mithaiandmore.in/cdn/shop/products/L00004_rajwadi-lassi_1024x1024.jpg?v=1628753217",
    price: 50,
    name: ["lassi", "lasi", "juice", "dairy","all"],
    para: "lassi",
    weight: "100g",
  },
  {
    id: 21,
    imgUrl:
      "https://m.media-amazon.com/images/I/71suj8wGr1L._AC_UF1000,1000_QL80_.jpg",
    price: 200,
    name: ["dahi", "curd", "dairy","all"],
    para: " sweet Curd",
    weight: "250g",
  },
  {
    id: 22,
    imgUrl: "https://www.sakthidairy.com/temp/Premium_Curd.jpg",
    price: 50,
    name: ["dahi", "curd", "dairy","all"],
    para: " Sour Curd",
    weight: "250g",
  },
  {
    id: 23,
    imgUrl:
      "https://www.backerhausveit.com/wp-content/uploads/2021/03/17783-1.jpg",
    price: 50,
    name: ["bread", "bred", "dairy","all"],
    para: "Bread",
    weight: "250g",
  },
  {
    id: 24,
    imgUrl:
      "https://www.shutterstock.com/image-photo/fresh-sweet-strawberry-isolated-on-260nw-106641707.jpg",
    price: 50,
    name: ["fruits", "strawberry", "berry", "straberry","all"],
    para: " strawberry",
    weight: "250g",
  },
  {
    id: 25,
    imgUrl:
      "https://www.verywellfit.com/thmb/qeIiD7JDWsOr4_Ymg4GCaxhhOZs=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/Bananas-5c6a36a346e0fb0001f0e4a3.jpg",
    price: 50,
    name: ["fruits", "banana", "kela","all"],
    para: " Banana",
    weight: "3 pieces",
  },
  {
    id: 26,
    imgUrl:
      "https://naturals.pk/cdn/shop/products/apple-kalakulu_533x.jpg?v=1593218784",
    price: 50,
    name: ["fruits", "apple", "seb","all"],
    para: " apple",
    weight: "500 g",
  },
  {
    id: 27,
    imgUrl:
      "https://cdn.shopify.com/s/files/1/0434/5475/9072/products/FRU38_1_large.png?v=1628239485",
    price: 100,
    name: ["fruits", "orange", "santra","all"],
    para: " orange",
    weight: "500 g",
  },
  {
    id: 28,
    imgUrl:
      "https://cdn.cdnparenting.com/articles/2019/03/14174045/794794447-H-1024x700.webp",
    price: 100,
    name: ["fruits", "gava", "Amrood", "amrud","all"],
    para: " Gava",
    weight: "500 g",
  },
  {
    id: 29,
    imgUrl:
      "https://pizza.cafeela.pk/wp-content/uploads/2019/08/Coke-500ml.jpg",
    price: 100,
    name: ["juice", "cold dring", "coke", "coca cola","all"],
    para: " coca cola",
    weight: "500 g",
  },
  {
    id: 30,
    imgUrl:
      "https://gharstuff.com/wp-content/uploads/2018/12/Sprite-Soft-Drink-Can-300ml.jpg",
    price: 100,
    name: ["juice", "cold dring", "sprite","all"],
    para: "sprite",
    weight: "300 g",
  },
  {
    id: 31,
    imgUrl:
      "https://growstar.in/wp-content/uploads/2021/07/51kQMEbZxL._SL1000_-min-1.jpg",
    price: 100,
    name: ["juice", "cold dring", "coke", "coca cola","all"],
    para: "coke",
    weight: "300 g",
  },
  {
    id: 32,
    imgUrl:
      "https://5.imimg.com/data5/SELLER/Default/2023/4/302611051/HS/FZ/MS/101915868/300ml-thums-ups-cold-drink-can.jpg",
    price: 100,
    name: ["juice", "cold dring", "thums up", "thumsup","all"],
    para: "thums up",
    weight: "300 g",
  },
  {
    id: 33,
    imgUrl:
      "https://static.wixstatic.com/media/c06c49_db1e971e769e4d78a686f6146277c259~mv2.png/v1/fill/w_280,h_280,q_90/c06c49_db1e971e769e4d78a686f6146277c259~mv2.png",
    price: 100,
    name: ["juice", "cold dring", "pepsi", "pepsi","all"],
    para: "pepsi",
    weight: "300 g",
  },
  {
    id: 34,
    imgUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcThxsnFVJb_eLQF63RTevFtv3bs0vJ6tB4lEw&s",
    price: 20,
    name: ["snacks", "snack", "badam","all"],
    para: "badam",
    weight: "30 g",
  },
  {
    id: 35,
    imgUrl:
      "https://s7ap1.scene7.com/is/image/itcportalprod/ProductCard%20Hashtags_Default_Mobile_968x968_4x?fmt=webp-alpha",
    price: 20,
    name: ["snacks", "snack", "chips","all"],
    para: "chips",
    weight: "30 g",
  },
  {
    id: 36,
    imgUrl:
      "https://m.media-amazon.com/images/I/71+bz5i4SDL._AC_UF1000,1000_QL80_.jpg",
    price: 20,
    name: ["snacks", "snack", "chips", "lay's chips","all"],
    para: "aalu lay's chips",
    weight: "30 g",
  },
  {
    id: 37,
    imgUrl:
      "https://www.jiomart.com/images/product/original/490000331/lay-s-india-s-magic-masala-potato-chips-40-g-product-images-o490000331-p490000331-0-202410251815.jpg?im=Resize=(420,420)",
    price: 40,
    name: ["snacks", "snack", "chips", "lay's chips", "magic masala chips","all"],
    para: "magic masala chips",
    weight: "30 g",
  },
  {
    id: 38,
    imgUrl:
      "https://www.jiomart.com/images/product/original/490000331/lay-s-india-s-magic-masala-potato-chips-40-g-product-images-o490000331-p490000331-0-202410251815.jpg?im=Resize=(420,420)",
    price: 40,
    name: ["snacks", "snack", "chips", "lay's chips", "magic masala chips","all"],
    para: "magic masala chips",
    weight: "30g",
  },
  {
    id: 39,
    imgUrl: "https://garnifoods.com/images/specialCategory/garam-masala.jpg",
    price: 150,
    name: ["masala", "kitchen masala", "garam masala", "chhola","all"],
    para: "garam masala",
    weight: "150g",
  },
  {
    id: 40,
    imgUrl:
      "https://arunamasalas.com/wp-content/uploads/2020/10/a1-chilli-powder-570x684.jpg",
    price: 150,
    name: ["masala", "Chili power", "mirch power","all"],
    para: "Chilly power",
    weight: "150g",
  },
  {
    id: 41,
    imgUrl:
      "https://arunamasalas.com/wp-content/uploads/2020/10/kashmiri-chilly-570x684.jpg",
    price: 150,
    name: ["masala", "Chili power", "mirch power","all"],
    para: "kashimiri chilly power",
    weight: "150g",
  },
  {
    id: 42,
    imgUrl:
      "https://mathafoods.com/cdn/shop/files/WhatsAppImage2024-04-24at12.16.53PM.jpg?v=1713942099&width=360",
    price: 150,
    name: ["masala", "chicken power","all"],
    para: "chicken power",
    weight: "50g",
  },
  {
    id: 43,
    imgUrl:
      "https://arunamasalas.com/wp-content/uploads/2020/10/biriyani-masala.jpg",
    price: 150,
    name: ["masala", "Biryani power","all"],
    para: "biryani power",
    weight: "50g",
  },
  {
    id: 44,
    imgUrl: "https://m.media-amazon.com/images/I/61A1MNF8b2L.jpg",
    price: 150,
    name: ["masala", "mustord oil", "oil","all"],
    para: "fortune mustord oil",
    weight: "1kg",
  },
  {
    id: 45,
    imgUrl: "https://m.media-amazon.com/images/I/61kSnyPT35L.jpg",
    price: 150,
    name: ["masala", "oil", "refined","all"],
    para: "fortune sunflower oil",
    weight: "1kg",
  },
  {
    id: 46,
    imgUrl: "https://m.media-amazon.com/images/I/61+ESe18blL.jpg",
    price: 50,
    name: ["chocolates", "DairyMilk","all"],
    para: "DairyMilk",
    weight: "1 piece",
  },
  {
    id: 47,
    imgUrl: "https://cococart.in/cdn/shop/files/1CH2561.png?v=1727968372",
    price: 50,
    name: ["chocolates", "DairyMilk","all"],
    para: "DairyMilk",
    weight: "2 piece",
  },
  {
    id: 48,
    imgUrl: "https://m.media-amazon.com/images/I/618fySthK8L.jpg",
    price: 50,
    name: ["chocolates", "5 star","all"],
    para: "5 star",
    weight: "2 piece",
  },
  {
    id: 49,
    imgUrl:
      "https://fbflowerbasket.com/wp-content/uploads/2023/11/5-Cadbury-Five-Star-Chocolates-20-gms.jpg",
    price: 100,
    name: ["chocolates", "5 star","all"],
    para: "5 star",
    weight: "5 piece",
  },

  {
    id: 1,
    imgUrl:
      "https://www.meathouseindia.com/wp-content/uploads/2022/08/mutton-curry-cutside-view.jpg",
    name: ["Mutton", "nonveg", "Meat","all"],
    price: 800,
    para: "Fresh mutton",
    weight: "1kg",
  },
  {
    id: 2,
    imgUrl:
      "https://jagsfresh-bucket.s3.amazonaws.com/media/package/img_one/2023-11-01/mutton_500g__1kg.jpg",
    name: ["Mutton", "nonveg", "Meat","all"],
    price: 400,
    para: "fresh mutton",
    weight: "500g",
  },
  {
    id: 3,
    imgUrl:
      "https://cdn.grofers.com/cdn-cgi/image/f=auto,fit=scale-down,q=70,metadata=none,w=360/app/assets/products/sliding_images/jpeg/c0a8ea75-a19c-47b6-b3c8-6ee37a33e14a.jpg?ts=1705489313",
    name: ["Leg Piece", "nonveg", "murgi","all"],
    price: 100,
    para: "chicken legs",
    weight: "500g",
  },
  {
    id: 4,
    imgUrl:
      "https://www.chickendelight.com.au/wp-content/uploads/2020/07/Chicken-Whole-3.jpg",
    name: ["Leg Piece", "nonveg", "murgi","all"],
    price: 300,
    para: "whole size chicken",
    weight: "2kg",
  },
  {
    id: 5,
    imgUrl:
      "https://5.imimg.com/data5/UB/GK/MY-728206/fish-pangasius-pangas-baikar-500x500.jpg",
    name: ["baiki", "fish", "nonveg", "baiki fish", "badi fish","all"],
    price: 90,
    para: "baiki fish",
    weight: "500g",
  },
  {
    id: 6,
    imgUrl: "https://5.imimg.com/data5/VK/NP/MY-27605712/pangasius-fish.jpg",
    name: ["baiki", "fish", "nonveg", "baiki fish", "badi fish","all"],
    price: 170,
    para: "baiki fish",
    weight: "1kg",
  },
  {
    id: 7,
    imgUrl:
      "https://bombayfreshfish.com/wp-content/uploads/2022/10/Rohu-Main.jpg",
    name: ["rohu", "fish", "nonveg", "rohu fish","all"],
    price: 180,
    para: "rohu fish",
    weight: "1kg",
  },
  {
    id: 8,
    imgUrl: "https://capon.in/media/2022/04/fresh-rohu-fish-capon.jpg",
    name: ["rohu", "fish", "nonveg", "rohu fish","all"],
    price: 100,
    para: "rohu fish",
    weight: "500g",
  },
];

export const ProductsCategories = [
  {
    imgUrl: "https://thumbs.dreamstime.com/b/local-market-farmer-selling-vegetables-produce-his-stall-awning-modern-flat-style-realistic-vector-illustration-isolated-69723395.jpg",
    category: "all",
  },
  {
    imgUrl:
      "https://cdn.grofers.com/cdn-cgi/image/f=auto,fit=scale-down,q=70,metadata=none,w=360/app/assets/products/sliding_images/jpeg/c0a8ea75-a19c-47b6-b3c8-6ee37a33e14a.jpg?ts=1705489313",
    category: "nonveg",
  },
  {
    imgUrl:
      "https://www.mooringspark.org/hs-fs/hubfs/bigstock-fresh-vegetables-on-the-white--13481840.jpg?width=900&name=bigstock-fresh-vegetables-on-the-white--13481840.jpg",
    category: "sabji",
  },
  {
    imgUrl:
      "https://cdn.grofers.com/cdn-cgi/image/f=auto,fit=scale-down,q=70,metadata=none,w=270/da/cms-assets/cms/product/2053a0d2-82b3-4ab3-a2f0-da4fe15df384.jpg?ts=1729165845",
    category: "egg",
  },
  {
    imgUrl:
      "https://mariebelle.com/cdn/shop/files/Fruit-Infused.jpg?v=1718131753&width=2854",
    category: "fruits",
  },
  {
    imgUrl:
      "https://images.jdmagicbox.com/quickquotes/images_main/cold-drink-2009254300-83qu5vbj.jpg",
    category: "cold dring",
  },
  {
    imgUrl: "https://m.media-amazon.com/images/I/71d03CE9a5L.jpg",
    category: "snacks",
  },
  {
    imgUrl:
      "https://giftinday.com/wp-content/uploads/2021/05/Mix-20-Chocolate-min-1.jpg",
    category: "chocolates",
  },
  {
    imgUrl:
      "https://www.rmemart.com/s/62afda9f5dd6de16b52ff6be/62d21c1e06932ca9ccfff96d/food-and-oil-min-480x480.webp",
    category: "masala",
  },
  {
    imgUrl:
      "https://cdn.grofers.com/cdn-cgi/image/f=auto,fit=scale-down,q=70,metadata=none,w=270/layout-engine/2022-11/Slice-2_10.png",
    category: "dairy",
  },
  
  {
    imgUrl:
      "https://cdn.grofers.com/cdn-cgi/image/f=auto,fit=scale-down,q=70,metadata=none,w=270/app/assets/products/sliding_images/jpeg/0c0170fb-baf2-4947-b512-a6f0a5e6ad01.jpg?ts=1711024455",
    category: "sabji",
  },
  {
    imgUrl:
      "https://cdn.grofers.com/cdn-cgi/image/f=auto,fit=scale-down,q=70,metadata=none,w=270/da/cms-assets/cms/product/2053a0d2-82b3-4ab3-a2f0-da4fe15df384.jpg?ts=1729165845",
    category: "egg",
  },
];

export const banners = [
  {
    id: 1,
    image:
      "https://www.asknestle.in/sites/default/files/styles/webp/public/2022-10/Green-Leafy-Vegetables-1250x380.jpg.webp",
    alt: "Banner 1",
  },
  {
    id: 2,
    image:
      "https://img.freepik.com/premium-photo/food-panorama-black-background-with-copy-space-flat-lay-various-products-shot-from-top-meat-fish-chicken-shrimps-vegetables-fruits-wine-cheese-with-place-text_1210158-1623.jpg",
    alt: "Banner 2",
  },
  {
    id: 3,
    image:
      "https://png.pngtree.com/background/20210711/original/pngtree-snack-food-taobao-banner-picture-image_1105110.jpg",
    alt: "Banner 3",
  },
  {
    id: 4,
    image:
      "https://5.imimg.com/data5/NU/XC/MY-58864/carbonated-drinks-250x250.png",
    alt: "Banner 3",
  },
  {
    id: 5,
    image:
      "https://img.freepik.com/free-vector/farm-milk-poster_1284-74094.jpg",
    alt: "Banner 3",
  },
  {
    id: 6,
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQInFhIeL1RtO4LxGH7O52Mo1o-qy-yo9Kpqg&s",
    alt: "Banner 3",
  },
  {
    id: 7,
    image:
      "https://pi.nice-cdn.com/upload/image/product/large/default/lindt-milk-chocolate-bar-100-g-1189652-en.jpg",
    alt: "Banner 3",
  },
];

export const reviews = [
  {
    dpText: "A",
    title: "Our Values",
    para: `Customer-centricity is at the core of everything we do. 
    We are committed to offering quality products, transparent pricing, and outstanding customer service.`,
  },
  {
    dpText: "S",
    title: "  Why Choose Us?",
    para: `We focus on providing fast delivery,
     hassle-free returns, and exceptional customer support.
      Your satisfaction is our priority, and we strive to make your shopping experience enjoyable.`,
  },
  {
    dpText: "D",
    title: "  Our Mission",
    para: `At Dukaan, we are on a mission to make online shopping more convenient and affordable. 
    Our goal is to provide a platform where you can find everything you need with just a few clicks..`,
  },
];